import { PickingInfo } from '@deck.gl/core/typed';
import { BaseMap } from 'components/maps/BaseMap';
import { getLocationMarkerLayer } from 'components/maps/utils';
import React, { useCallback, useMemo } from 'react';
import { Position } from 'types/geojson';

const ZOOM_LEVEL = 16;

export type PointGeometryMapProps = {
  onPinDrop?: (coordinates: Position) => void;
  isPinActive?: boolean;
  setPinActive?: (value: boolean) => void;
  coordinates?: Position;
};

export const PointGeometryMap: React.FunctionComponent<PointGeometryMapProps> = ({
  onPinDrop,
  isPinActive,
  setPinActive,
  coordinates,
}) => {
  const handleDropPin = useCallback(
    (info: PickingInfo) => {
      if (!isPinActive) {
        return;
      }
      // Forcing the type to our Position type in case we need to swap out turf.js in the future
      onPinDrop?.(info.coordinate as Position);
      setPinActive?.(false);
    },
    [isPinActive, onPinDrop, setPinActive]
  );

  const viewState = useMemo(() => {
    return coordinates
      ? {
          latitude: coordinates[1],
          longitude: coordinates[0],
          zoom: ZOOM_LEVEL,
        }
      : undefined;
  }, [coordinates]);

  const markerLayer = useMemo(() => {
    return getLocationMarkerLayer(coordinates as number[]);
  }, [coordinates]);

  return (
    <BaseMap
      viewState={viewState}
      deckProps={{
        onClick: handleDropPin,
      }}
      previewLayers={[markerLayer] as any}
    />
  );
};
